import { z } from 'zod';

export const OPTION_TEMPID_PREFIX = 'TEMP_OPTION_ID_';

export const OptionFormSchema = z.object({
  names: z.array(
    z.object({
      name: z.string().min(1, 'Option Name is required').max(180).trim(),
      sortOrder: z.number().nonnegative(),
      optionId: z.string().startsWith(OPTION_TEMPID_PREFIX).or(z.uuid()),
      templateOptionIds: z.string().array(),
    })
  ),
  optionType: z.enum(['MANUAL', 'TEMPLATE']),
});

export type OptionFormInputs = z.infer<typeof OptionFormSchema>;
